import { useMutation } from "@shared/lib/hooks";
import { ToastService } from "@shared/lib/services";
import { AddBy } from "@shared/lib/types";
import { BUCKET_LIST_QUERY_KEY } from "../constants";
import { BucketService } from "../services/bucket.service";

export function useAddCreatorsToBuckets() {
  const {
    mutate: addToBucket,
    isLoading: isAdding,
    isSuccess: isAdded,
    error: addToBucketError,
  } = useMutation({
    mutationFn: async ({
      bucketIds,
      addBy,
    }: {
      bucketIds: string[];
      addBy: AddBy[];
    }) => {
      return await BucketService.addCreatorsToBuckets({
        bucketIds,
        addBy,
      }).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      });
    },
    options: {
      queryKey: [...BUCKET_LIST_QUERY_KEY],
      skipInvalidation: false,
    },
    onSuccess: (c, _) => {
      c.invalidateQueries({ queryKey: BUCKET_LIST_QUERY_KEY });
    },
  });
  return {
    addToBucket,
    isAdding,
    isAdded,
    addToBucketError,
  };
}
